import { Dashboard as DashboardIcon } from "@volt_developers/react-ui-components";

import { lazyRetry } from "../../../utils/lazyRetry";

import type { Route } from "../../../routes/RouteModel";

const Dashboard = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "Dashboard" */
      /* webpackPrefetch: true */
      "../pages/Dashboard"
    ),
  "Dashboard"
);

export const dashboardRoutes: Route = {
  i18nName: "Dashboard",
  path: "/",
  icon: DashboardIcon,
  component: Dashboard,
  newTheme: true,
};
